import axios from "axios";
import store from "../store";
import router from "../router";
import api from "../conf/ruta-base";

export const aggregateHeaders = (config) => {
  const identity = sessionStorage.getItem("identityClientI");
  const host = sessionStorage.getItem("identityClientH");
  const auth_token = sessionStorage.getItem("token");
  config.headers = config.headers || {};

  if (identity) {
    config.headers['x-identity'] = identity;
  }
  if (host) {
    config.headers['x-host'] = host;
  }
  if (auth_token) {
    config.headers['Authorization'] = "Bearer " + auth_token;
  }

  return config;
}

const axiosInterceptor = () => {
  axios.interceptors.request.use(
    function (config) {
      store.commit("loading", true);

      //config.headers = config.headers || {};
      aggregateHeaders(config);
      return config;

    },
    function (error) {
      store.commit("loading", false);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      store.commit("loading", false);
      return response;
    },
    function (error) {
      const originalRequest = error.config;
      if (
        (error.response.status === 401 || error.response.status === 403) &&
        originalRequest.url ===
        api.api + "/auth/refresstoken"
      ) {
        sessionStorage.removeItem("token");
        store.commit("loading", false);
        router.push("login");
        return Promise.reject(error);
      }
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        sessionStorage.token = sessionStorage.getItem("refress_token")

        return axios
          .get(api.api + "/auth/refresstoken")
          .then((res) => {
            if (res.status === 200) {
              sessionStorage.token = res.data.access_token;
              axios.defaults.headers = {
                Authorization: "Bearer " + res.data.access_token,
              };
              return axios(originalRequest);
            } else {
              store.commit("loading", false);
              router.push("login");
            }
          })
      }
      store.commit("loading", false);
      return Promise.reject(error);
    }
  );
};

export default axiosInterceptor;